var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "drive-thumb", class: { folder: _vm.row.kind === "DIR" } },
    [
      _vm.url
        ? _c("img", {
            attrs: { src: _vm.url, alt: "", draggable: "false" },
            on: {
              error: function ($event) {
                _vm.url = ""
              },
            },
          })
        : _c("img", {
            staticClass: "drive-type-icon",
            attrs: {
              src: _vm.iconUrl,
              alt:
                _vm.iconKind === "folder" ? "文件夹" : _vm.iconKind + " 文件",
              draggable: "false",
            },
          }),
      _vm.syncing
        ? _c("i", {
            staticClass: "drive-sync-arrow el-icon-top",
            attrs: { title: "正在同步", "aria-label": "正在同步" },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }